import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from "../assets/images/logo.jpeg";
const footerLinks = {
  Company: [
    { label: 'About Us', path: '/about' },
    { label: 'Our Values', path: '/about#values' },
    { label: 'Careers', path: '/careers' },
    { label: 'Case Studies', path: '/case-studies' },
    { label: 'Technology', path: '/technology' },
  ],
  Services: [
    { label: 'Electronic Design', path: '/services#design' },
    { label: 'PCB Fabrication', path: '/services#pcb' },
    { label: 'EMS Solutions', path: '/services#ems' },
    { label: 'Box Build Assembly', path: '/services#boxbuild' },
    { label: 'Component Sourcing', path: '/services#sourcing' },
  ],
  Industries: [
    { label: 'Automotive', path: '/industries#automotive' },
    { label: 'Medical Devices', path: '/industries#medical' },
    { label: 'Industrial & IoT', path: '/industries#industrial' },
    { label: 'Energy Systems', path: '/industries#energy' },
    { label: 'Consumer Electronics', path: '/industries#consumer' },
  ],
};

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top container">
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
  <img src={logo} alt="Zxeon FS Logo" className="footer__logo-img" />
</Link>
          {/* <p className="footer__tagline">
            Transforming ideas into world-class electronic products through comprehensive design and manufacturing excellence.
          </p> */}
          <div className="footer__certifications">
            <span className="cert-badge">ISO 9001</span>
            <span className="cert-badge">ISO 14001</span>
            <span className="cert-badge">RoHS Compliant</span>
          </div>
        <div className="footer__social">
  {/* LinkedIn */}
  <a
    href="https://linkedin.com/in/zxeon-fs"
    target="_blank"
    rel="noreferrer"
    className="social-link"
    aria-label="LinkedIn"
  >
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  </a>

  {/* Instagram */}
  <a
    href="https://www.instagram.com/zxeon_fs/"
    target="_blank"
    rel="noreferrer"
    className="social-link"
    aria-label="Instagram"
  >
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M7.75 2C4.57 2 2 4.57 2 7.75v8.5C2 19.43 4.57 22 7.75 22h8.5C19.43 22 22 19.43 22 16.25v-8.5C22 4.57 19.43 2 16.25 2h-8.5zm0 2h8.5A3.75 3.75 0 0120 7.75v8.5A3.75 3.75 0 0116.25 20h-8.5A3.75 3.75 0 014 16.25v-8.5A3.75 3.75 0 017.75 4zm8.75 1a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z" />
    </svg>
  </a>

  {/* X (Twitter) */}
  <a
    href="https://x.com/ZxeonFS"
    target="_blank"
    rel="noreferrer"
    className="social-link"
    aria-label="X"
  >
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M22.46 6c-.77.35-1.5.58-2.24.69a3.92 3.92 0 001.72-2.16 7.72 7.72 0 01-2.47.94 3.89 3.89 0 00-6.73 2.66c0 .3.03.6.1.88A11.04 11.04 0 013 4.79a3.9 3.9 0 001.2 5.19 3.83 3.83 0 01-1.76-.49v.05a3.9 3.9 0 003.12 3.82c-.33.09-.68.14-1.04.14-.25 0-.5-.02-.74-.07a3.9 3.9 0 003.64 2.7A7.8 7.8 0 012 18.58a11 11 0 005.95 1.74c7.14 0 11.05-5.92 11.05-11.05v-.5A7.72 7.72 0 0022.46 6z" />
    </svg>
  </a>
</div>
        </div>

        <div className="footer__links-grid">
          {Object.entries(footerLinks).map(([group, items]) => (
            <div key={group} className="footer__link-group">
              <h4 className="footer__link-heading">{group}</h4>
              <ul>
                {items.map((item) => (
                  <li key={item.path}>
                    <Link to={item.path} className="footer__link">{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="footer__link-group">
            <h4 className="footer__link-heading">Contact</h4>
            <ul className="footer__contact-list">
              <li>
  <span className="contact-icon">📍</span>
  <span>
  No. 123-127, 1st Floor<br />
  Metagalli Industrial Area<br />
  Mysore - 570016<br />
  Karnataka, India
</span>
</li>
              <li>
                <span className="contact-icon">✉️</span>
                <a href="mailto:info@zxeonfs.com" className="footer__link">info@zxeonfs.com</a>
              </li>
              <li className="flex items-center gap-2">
  <span className="contact-icon">📞</span>

  <a
    href="tel:+918214244515"
    className="hover:text-blue-600 transition-colors"
  >
    +91 821 4244515
  </a>
</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom container">
  <p className="footer__copy">
    © {new Date().getFullYear()} Zxeon FS Private Limited. All rights reserved.
  </p>

  <p className="footer__design">
    | Designed by{" "}
    <a
      href="https://consolewaves.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="footer__link"
    >
      ConsoleWaves
    </a>
  </p>
</div>
    </footer>
  );
}
